import script from "./MonthlyBilling.vue?vue&type=script&setup=true&lang=js"
export * from "./MonthlyBilling.vue?vue&type=script&setup=true&lang=js"

import "./MonthlyBilling.vue?vue&type=style&index=0&id=35dae0fc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35dae0fc"]])

export default __exports__